/* ============================================================
   penovia-menue.js  —  eigene Datei (Ebene B)
   Baustein 3, 31.08.2026.

   Steuert die Navigation aus snippets/penovia-navigation.liquid:

   - Der Kasten wird einmalig aus dem Kopfbereich heraus direkt an
     #header gehaengt. Nur so sitzt er buendig unter der Kopfzeile
     und ueber die volle Breite. Nebeneffekt und eigentlicher Grund:
     die tief verschachtelten Theme-Regeln greifen dann nicht mehr,
     und penovia-marke.css braucht kein einziges !important.
   - Klick auf den Menuepunkt klappt auf und zu. Klick daneben und
     die Esc-Taste schliessen ebenfalls.
   - In der linken Leiste wechselt beim Ueberfahren die Gruppe,
     die rechts angezeigt wird. Ein Klick folgt dem Link.
   ============================================================ */
(function () {
  'use strict';

  var AUF = 'penovia-auf';
  var AKTIV = 'penovia-leiste__punkt--aktiv';
  var GRUPPE_AKTIV = 'penovia-gruppe--aktiv';

  function schliesseAlle(kopf) {
    var offen = kopf.querySelectorAll('.penovia-kasten.' + AUF);
    for (var i = 0; i < offen.length; i++) {
      offen[i].classList.remove(AUF);
      if (offen[i].penoviaAusloeser) offen[i].penoviaAusloeser.setAttribute('aria-expanded', 'false');
    }
  }

  function zeigeGruppe(kasten, nummer) {
    var punkte = kasten.querySelectorAll('.penovia-leiste__punkt');
    for (var i = 0; i < punkte.length; i++) {
      punkte[i].classList.toggle(AKTIV, punkte[i].getAttribute('data-penovia-gruppe') === nummer);
    }
    var gruppen = kasten.querySelectorAll('.penovia-gruppe');
    for (var j = 0; j < gruppen.length; j++) {
      gruppen[j].classList.toggle(GRUPPE_AKTIV, gruppen[j].getAttribute('data-penovia-gruppe') === nummer);
    }
  }

  function baue() {
    var kopf = document.getElementById('header');
    if (!kopf) return;

    var kaesten = kopf.querySelectorAll('.penovia-kasten');
    if (!kaesten.length) return;

    for (var i = 0; i < kaesten.length; i++) {
      (function (kasten) {
        var name = kasten.getAttribute('data-penovia-menue');
        var ausloeser = kopf.querySelector('[data-penovia-oeffnet="' + name + '"]');
        if (!ausloeser) return;

        // An den Kopfbereich haengen, damit der Kasten unter der
        // Kopfzeile sitzt und keine Theme-Regel mehr auf ihn passt.
        kopf.appendChild(kasten);
        kasten.penoviaAusloeser = ausloeser;
        ausloeser.setAttribute('aria-haspopup', 'true');
        ausloeser.setAttribute('aria-expanded', 'false');

        ausloeser.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var warOffen = kasten.classList.contains(AUF);
          schliesseAlle(kopf);
          if (!warOffen) {
            kasten.classList.add(AUF);
            ausloeser.setAttribute('aria-expanded', 'true');
          }
        });

        // Linke Leiste: Ueberfahren wechselt die Gruppe rechts.
        var punkte = kasten.querySelectorAll('.penovia-leiste__punkt');
        for (var k = 0; k < punkte.length; k++) {
          (function (p) {
            var nummer = p.getAttribute('data-penovia-gruppe');
            p.addEventListener('mouseenter', function () { zeigeGruppe(kasten, nummer); });
            p.addEventListener('focus', function () { zeigeGruppe(kasten, nummer); });
          })(punkte[k]);
        }
      })(kaesten[i]);
    }

    // Klick daneben schliesst. Klicks im Kasten nicht, sonst waeren
    // die Links darin nicht erreichbar.
    document.addEventListener('click', function (e) {
      var t = e.target;
      while (t) {
        if (t.classList && t.classList.contains('penovia-kasten')) return;
        t = t.parentNode;
      }
      schliesseAlle(kopf);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) schliesseAlle(kopf);
    });
  }

  /* ---------- Handy und Tablet ----------
     Schublade auf und zu, dazu zwei Ebenen Ziehharmonika.
     Markup: snippets/penovia-kopf-mobil.liquid */
  function baueMobil() {
    var knopf = document.querySelector('.penovia-mobil__knopf');
    var schublade = document.querySelector('.penovia-mobil__schublade');
    var vorhang = document.querySelector('.penovia-mobil__vorhang');
    if (!knopf || !schublade || !vorhang) return;

    function auf() {
      schublade.classList.add('penovia-mobil__schublade--auf');
      vorhang.hidden = false;
      knopf.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function zu() {
      schublade.classList.remove('penovia-mobil__schublade--auf');
      vorhang.hidden = true;
      knopf.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    knopf.addEventListener('click', function () {
      if (schublade.classList.contains('penovia-mobil__schublade--auf')) zu(); else auf();
    });
    vorhang.addEventListener('click', zu);
    var zuKnopf = schublade.querySelector('.penovia-mobil__zu');
    if (zuKnopf) zuKnopf.addEventListener('click', zu);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) zu();
    });

    var schalter = schublade.querySelectorAll('.penovia-mobil__auf');
    for (var i = 0; i < schalter.length; i++) {
      (function (s) {
        s.addEventListener('click', function () {
          var inhalt = s.nextElementSibling;
          if (!inhalt) return;
          var offen = s.getAttribute('aria-expanded') === 'true';
          s.setAttribute('aria-expanded', offen ? 'false' : 'true');
          inhalt.hidden = offen;
        });
      })(schalter[i]);
    }
  }

  /* ---------- Wortwahl vereinheitlichen ----------
     Baustein 9, 02.09.2026.

     Der Shop sagt an zehn Stellen "Einkaufswagen" und ueberall sonst
     "Warenkorb" — in derselben Schublade steht oben "Warenkorb" und
     darunter "Der Einkaufswagen ist leer". Die Woerter stehen in
     locales/de.json, einer Theme-Datei: sie dort zu aendern kostete
     einen Eingriff auf Ebene C, und zwar den unangenehmsten — nach
     einem Update liefert Shopify eine neue Sprachdatei, und jede
     Aenderung muesste von Hand wieder hinein.

     Ersetzt wird deshalb hier, wie schon bei "Deine Mailadresse".
     Angefasst werden nur Textknoten, nicht ganze Elemente: ein
     innerHTML-Ersatz wuerde Verweise und Ereignisse darin zerstoeren.

     Der Warenkorb-Knopf der Produktseite steht bewusst NICHT in der
     Liste: dort heisst es "In den Warenkorb legen", und das kommt
     schon aus einer Einstellung. */
  var WORTE = [
    ['Einkaufswagen', 'Warenkorb'],
    ['Einkaufswagens', 'Warenkorbs']
  ];

  /* Die Schublade wird von ajax-cart.js nach jeder Aenderung neu
     aufgebaut — und beim Leeren schreibt sie einen Satz hinein, der fest
     in der Theme-Datei steht: "Ihr Einkaufswagen ist im Moment leer."

     Ein einmaliger Durchgang beim Laden erwischt ihn nicht. Gemessen:
     nach dem Herunterzaehlen auf null stand dort weiter
     "Einkaufswagen", waehrend die Ueberschrift darueber "Warenkorb"
     sagte. Ein Beobachter auf dem Inhalt der Schublade faengt das ab.

     Nur die Schublade, nicht das ganze Dokument: ein Beobachter ueber
     allem meldete bei jedem Bildwechsel und jedem Aufklappen. */
  function wortwahlBeobachten() {
    var kasten = document.querySelector('.enj-minicart-ajax');
    if (!kasten || !window.MutationObserver) return;
    var laeuft = false;
    var wache = new MutationObserver(function () {
      if (laeuft) return;
      laeuft = true;
      anredeVereinheitlichen();
      laeuft = false;
    });
    wache.observe(kasten, { childList: true, subtree: true });
  }

  function anredeVereinheitlichen() {
    /* Platzhalter: "Deine Mailadresse" steht als Locale-Schluessel
       general.newsletter_form.newsletter_footerh5 in locales/de.json.
       Kein regulaerer Ausdruck, mit Absicht — die Wortgrenze hat den Weg
       durch das Werkzeug nicht ueberlebt, mit dem diese Datei
       geschrieben wurde, und der Ausdruck traf danach lautlos nichts. */
    var felder = document.querySelectorAll('input[placeholder], textarea[placeholder]');
    for (var i = 0; i < felder.length; i++) {
      var p = felder[i].getAttribute('placeholder');
      if (p && p.indexOf('Deine ') === 0) {
        felder[i].setAttribute('placeholder', 'Ihre ' + p.slice(6));
      }
    }

    /* Wortwahl in allen Textknoten des Dokuments. */
    var lauf = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var knoten, zuAendern = [];
    while ((knoten = lauf.nextNode())) {
      var eltern = knoten.parentNode;
      if (!eltern) continue;
      var tag = eltern.nodeName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA') continue;
      for (var w = 0; w < WORTE.length; w++) {
        if (knoten.nodeValue.indexOf(WORTE[w][0]) !== -1) { zuAendern.push(knoten); break; }
      }
    }
    for (var n = 0; n < zuAendern.length; n++) {
      var t = zuAendern[n].nodeValue;
      for (var w2 = 0; w2 < WORTE.length; w2++) t = t.split(WORTE[w2][0]).join(WORTE[w2][1]);
      zuAendern[n].nodeValue = t;
    }

    /* Auch Beschriftungen, die nicht im Text stehen. */
    var mitTitel = document.querySelectorAll('[aria-label], [title], input[type=submit]');
    for (var m = 0; m < mitTitel.length; m++) {
      for (var a = 0; a < 3; a++) {
        var attr = ['aria-label', 'title', 'value'][a];
        var v = mitTitel[m].getAttribute(attr);
        if (!v || v.indexOf('Einkaufswagen') === -1) continue;
        mitTitel[m].setAttribute(attr, v.split('Einkaufswagen').join('Warenkorb'));
      }
    }
  }



  /* ---------- Tote Platzhalterbilder entfernen ----------
     Baustein 8, 02.09.2026.

     Das Theme greift an mehreren Stellen auf placehold.it zurueck, wenn
     eine Bildeinstellung leer ist — im Fuss (247x23, Zahlungs-Symbole)
     und fest im Markup des Newsletter-Fensters (318x400).

     Den Dienst gibt es seit Jahren nicht mehr. Das ist nicht nur ein
     kaputtes Bild: Es ist eine FREMDE, TOTE Domain, die jede Seite dieses
     Shops anfragt. Wer sie kauft, bekommt Zugriffe aus dem ganzen Shop —
     und koennte dort ausliefern, was er will.

     Der Fussbereich ist ueber die Einstellung erledigt (dort liegt jetzt
     ein durchsichtiges Bild in den Shopify-Dateien). Diese Regel faengt
     den Rest ab, auch kuenftige Stellen: Ein Bild von einer toten Domain
     zeigt ohnehin nichts, entfernen kann es also nur besser machen. */
  function totePlatzhalterEntfernen() {
    var tote = document.querySelectorAll('img[src*="placehold.it"]');
    for (var i = 0; i < tote.length; i++) tote[i].remove();
  }

  /* ---------- Inhaltsseiten kenntlich machen ----------
     Baustein 8, 02.09.2026.

     Der Text der Inhaltsseiten lief ueber die volle Containerbreite —
     gemessen 1110px auf einem 1440er Schirm. Das liest sich schlecht;
     angenehm sind 60 bis 80 Zeichen je Zeile.

     Die Vorlage templates/page.liquid gibt dafuer keinen Anker her: kein
     Klassenname am Body, keiner am Abschnitt, und Shopify.template setzt
     dieses Theme nicht. Statt die Theme-Datei anzufassen (Ebene C) wird
     der Body hier ausgezeichnet.

     Erkennungsmerkmal ist der Titelblock der Standardvorlage. Gemessen:
     er steht auf /pages/uber-uns, /pages/b2b und /pages/impressum — und
     NICHT auf /pages/contact, die eine eigene Vorlage hat. Genau die
     Trennung, die gebraucht wird. */
  function inhaltsseiteKennzeichnen() {
    if (document.location.pathname.indexOf('/pages/') !== 0) return;
    if (!document.querySelector('.maxus-titlebox__title')) return;
    document.body.classList.add('penovia-inhaltsseite');
  }

  /* ---------- Produktreihe schieben ----------
     Markup: sections/penovia-auswahl.liquid
     Geschoben wird um eine Kartenbreite. Die Pfeile schalten sich
     ab, sobald der Anfang oder das Ende erreicht ist. */
  function baueReihe() {
    var buehnen = document.querySelectorAll('.penovia-auswahl__buehne');
    for (var i = 0; i < buehnen.length; i++) {
      (function (buehne) {
        var spur = buehne.querySelector('.penovia-auswahl__spur');
        var links = buehne.querySelector('.penovia-auswahl__pfeil--links');
        var rechts = buehne.querySelector('.penovia-auswahl__pfeil--rechts');
        if (!spur || !links || !rechts) return;

        function schritt() {
          var karte = spur.querySelector('.penovia-karte');
          if (!karte) return 300;
          var stil = getComputedStyle(spur);
          return karte.getBoundingClientRect().width + parseFloat(stil.columnGap || stil.gap || 0);
        }
        function pruefe() {
          var maxLinks = spur.scrollWidth - spur.clientWidth - 2;
          links.disabled = spur.scrollLeft <= 2;
          rechts.disabled = spur.scrollLeft >= maxLinks;
        }
        links.addEventListener('click', function () { spur.scrollLeft -= schritt(); });
        rechts.addEventListener('click', function () { spur.scrollLeft += schritt(); });
        spur.addEventListener('scroll', pruefe, { passive: true });
        window.addEventListener('resize', pruefe);
        // Beim ersten Aufruf stehen die Bildmasse noch nicht fest — deshalb
        // spaeter noch einmal nachrechnen, sonst bleibt der linke Pfeil aktiv,
        // obwohl die Reihe ganz am Anfang steht.
        window.addEventListener('load', pruefe);
        setTimeout(pruefe, 400);
        setTimeout(pruefe, 1500);
        pruefe();
      })(buehnen[i]);
    }
  }

  /* ---------- Bildwechsel auf den Produktkarten ----------
     Markup: sections/penovia-auswahl.liquid

     Zwei Sachen:
     - Ueber der Karte erscheint das zweite Produktbild.
     - Ueber einem Farbpunkt erscheint das Bild dieser Farbe.
       Der Farbpunkt gewinnt, solange der Zeiger auf ihm steht.

     Die Adressen stehen im Markup (data-zweit am Bild, data-bild am
     Punkt). Beim ersten Ueberfahren werden sie einmal vorgeladen, damit
     der Wechsel nicht flackert. */
  function baueBildwechsel() {
    var karten = document.querySelectorAll('.penovia-karte');
    for (var i = 0; i < karten.length; i++) {
      (function (karte) {
        var bild = karte.querySelector('.penovia-karte__bild img');
        if (!bild) return;
        var erst = bild.getAttribute('data-erst') || bild.src;
        var zweit = bild.getAttribute('data-zweit');
        var vorgeladen = false;

        function lade() {
          if (vorgeladen) return;
          vorgeladen = true;
          var adressen = [];
          if (zweit) adressen.push(zweit);
          var punkte = karte.querySelectorAll('.penovia-punkt[data-bild]');
          for (var k = 0; k < punkte.length; k++) adressen.push(punkte[k].getAttribute('data-bild'));
          for (var m = 0; m < adressen.length; m++) { var v = new Image(); v.src = adressen[m]; }
        }
        function zeige(adresse) {
          if (adresse && bild.getAttribute('src') !== adresse) bild.setAttribute('src', adresse);
        }

        karte.addEventListener('mouseenter', function () { lade(); zeige(zweit || erst); });
        karte.addEventListener('mouseleave', function () { zeige(erst); });

        var punkte = karte.querySelectorAll('.penovia-punkt');
        for (var j = 0; j < punkte.length; j++) {
          (function (punkt) {
            var farbbild = punkt.getAttribute('data-bild');
            if (!farbbild) return;
            punkt.addEventListener('mouseenter', function () { lade(); zeige(farbbild); });
            punkt.addEventListener('mouseleave', function () { zeige(zweit || erst); });
          })(punkte[j]);
        }
      })(karten[i]);
    }
  }

  /* ---------- Kollektionsuebersicht: "Items" ----------
     Baustein 10, 02.09.2026.

     /collections ist von nirgendwo im Shop verlinkt, aber erreichbar und
     indexierbar. Die Theme-Section schreibt dort die Stueckzahl mit einem
     fest eingebauten englischen Wort:

         {{ count }} {{ count | pluralize: 'Item', 'Items' }}

     Das in der Section zu aendern waere ein achter Eingriff auf Ebene C
     fuer ein Wort auf einer Seite. Hier wird stattdessen der eine Kasten
     umgeschrieben, in dem es steht — kein Eintrag in der allgemeinen
     Wortliste, weil ein Ersatz von "Item" ueberall auch mitten in Woertern
     zuschlagen wuerde. */
  function kollektionslisteDeutsch() {
    var kaesten = document.querySelectorAll('.total_item');
    for (var i = 0; i < kaesten.length; i++) {
      var t = kaesten[i].textContent.replace(/\s+/g, ' ').trim();
      var zahl = t.match(/^[0-9.]+/);
      if (zahl) kaesten[i].textContent = zahl[0] + ' Artikel';
    }
    /* Dieselbe Kollektion, derselbe englische Name wie im Browser-Reiter:
       'All' ist Shopifys eingebaute Kollektion ueber alle Produkte. Sie
       laesst sich nicht umbenennen, weil es sie nur virtuell gibt. Der
       Seitentitel wird dafuer in layout/theme.liquid gefuehrt; hier steht
       sie als Kachel. Verglichen wird auf Gleichheit, nicht auf Enthalten —
       eine Kollektion des Kunden darf 'All' im Namen tragen. */
    var titel = document.querySelectorAll('.title_collection');
    for (var j = 0; j < titel.length; j++) {
      if (titel[j].textContent.trim() === 'All') titel[j].textContent = 'Alle Produkte';
    }
  }

  /* ---------- Kruemelpfad kuerzen ----------
     02.09.2026.

     Der letzte Eintrag des Kruemelpfads wiederholt den vollen Seitentitel —
     auf der B2B-Seite "B2B — Werbeartikel fuer Unternehmen", und 24 Pixel
     darunter steht derselbe Satz noch einmal in 32px. Zweimal dasselbe
     untereinander liest niemand zweimal; es kostet nur Breite.

     Gekuerzt wird ausschliesslich am Gedankenstrich mit Leerzeichen davor
     und dahinter. Das ist in diesem Shop die Trennung zwischen Name und
     Zusatz ("B2B — Werbeartikel fuer Unternehmen"), und sie kommt in keinem
     der kurzen Titel vor: "Ueber Uns" und "Impressum" bleiben unangetastet.
     Ein Bindestrich ohne Leerzeichen wird NICHT getroffen, sonst waere aus
     "Soft-Touch" ein "Soft" geworden. */
  function kruemelpfadKuerzen() {
    var letzter = document.querySelector('.bread-crumb strong');
    if (!letzter) return;
    var t = letzter.textContent.trim();
    var i = t.indexOf(' — ');
    if (i > 0) letzter.textContent = t.slice(0, i);
  }

  function los() {
    baue(); baueMobil(); baueReihe(); baueBildwechsel();
    inhaltsseiteKennzeichnen();
    totePlatzhalterEntfernen(); anredeVereinheitlichen(); wortwahlBeobachten();
    kollektionslisteDeutsch(); kruemelpfadKuerzen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', los);
  } else {
    los();
  }
})();
